import React from "react";
import { Popconfirm } from "antd";
import { PopconfirmProps } from "antd/lib/popconfirm";

const Feedback = (props: PopconfirmProps) => {
	return <Popconfirm {...props}></Popconfirm>;
};

export default Feedback;
